import { render, staticRenderFns } from "./TradingEchartsBar.vue?vue&type=template&id=2f7f3013&scoped=true&"
import script from "./TradingEchartsBar.vue?vue&type=script&lang=js&"
export * from "./TradingEchartsBar.vue?vue&type=script&lang=js&"
import style0 from "./TradingEchartsBar.vue?vue&type=style&index=0&id=2f7f3013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f3013",
  null
  
)

export default component.exports